var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.28 384.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed6c0c;}.cls-2{fill:#e05a00;}.cls-3{fill:#ffb600;}.cls-4{fill:#f6921e;}.cls-5{fill:#d85107;}.cls-6{fill:#e26600;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232,194.5l-11.2,46.4c14.4,3.2,58.4,17.6,64.8-8.8C292,204.9,246.4,198.5,232,194.5Z",
    transform: "translate(-56.66 -0.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.6,232.9c7.2-27.2-39.2-34.4-53.6-37.6l-11.2,45.6",
    transform: "translate(-56.66 -0.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248,131.3l-10.4,42.4c12,3.2,48.8,15.2,54.4-8.8C297.6,140.1,260,134.5,248,131.3Z",
    transform: "translate(-56.66 -0.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292,164.9c6.4-24.8-32-30.4-44-33.6l-10.4,42.4",
    transform: "translate(-56.66 -0.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.2,5.7C192-19.9,88,43.3,62.4,145.7c-25.6,103.2,36.8,207.2,140,232.8s207.2-36.8,232.8-140C460.8,136.1,398.4,32.1,295.2,5.7Zm38.4,159.2c-2.4,18.4-12.8,28-27.2,31.2,19.2,9.6,28.8,24.8,19.2,51.2-11.2,32.8-38.4,35.2-74.4,28.8l-8.8,35.2-20.8-6.4,8.8-34.4a127.88,127.88,0,0,0-16.8-4l-8.8,34.4L184,295.3l8.8-35.2c-4.8-1.6-9.6-2.4-15.2-4l-27.2-7.2,10.4-24,15.2,4a7.63,7.63,0,0,0,9.6-4.8l13.6-55.2a2.94,2.94,0,0,1,2.4.8c-.8,0-1.6-.8-2.4-.8l9.6-39.2c0-4.8-1.6-10.4-9.6-12l-15.2-4,5.6-22.4,28.8,7.2h0c4,.8,8.8,2.4,13.6,3.2l8.8-34.4,20.8,5.6-8.8,33.6c5.6,1.6,11.2,2.4,16.8,4l8-33.6,20.8,5.6-8.8,34.4C317.6,125.7,337.6,139.3,333.6,164.9Z",
    transform: "translate(-56.66 -0.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.4,145.7c-25.6,103.2,36.8,207.2,140,232.8s207.2-36.8,232.8-140S398.4,31.3,295.2,5.7m38.4,159.2c-2.4,18.4-12.8,28-27.2,31.2,19.2,9.6,28.8,24.8,19.2,51.2-11.2,32.8-38.4,35.2-74.4,28.8l-8.8,35.2-20.8-6.4,8.8-34.4a127.88,127.88,0,0,0-16.8-4l-8.8,34.4L184,295.3l8.8-35.2c-4.8-1.6-9.6-2.4-15.2-4l-27.2-7.2,10.4-24,15.2,4a7.63,7.63,0,0,0,9.6-4.8l13.6-55.2a2.94,2.94,0,0,1,2.4.8c-.8,0-1.6-.8-2.4-.8l9.6-39.2c0-4.8-1.6-10.4-9.6-12l-15.2-4,5.6-22.4,28.8,7.2h0c4,.8,8.8,2.4,13.6,3.2l8.8-34.4,20.8,5.6-8.8,33.6c5.6,1.6,11.2,2.4,16.8,4l8-33.6,20.8,5.6-8.8,34.4C317.6,125.7,337.6,139.3,333.6,164.9Z",
    transform: "translate(-56.66 -0.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M433.6,245.7l-104-104a33.66,33.66,0,0,1,4.8,24c-2.4,18.4-12.8,28-27.2,31.2,19.2,9.6,28.8,24.8,19.2,51.2-11.2,32.8-38.4,35.2-74.4,28.8l-8.8,35.2-21.6-7.2,8.8-34.4a127.88,127.88,0,0,0-16.8-4l-8.8,34.4-4.8-1.6,81.6,81.6C352,368.9,412.8,317.7,433.6,245.7Z",
    transform: "translate(-56.66 -0.01)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.4,249.7h0l36,36,6.4-25.6c-4.8-1.6-9.6-2.4-15.2-4Z",
    transform: "translate(-56.66 -0.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.4,106.5h0l-3.2,10.4a108.29,108.29,0,0,1,25.6,12Z",
    transform: "translate(-56.66 -0.01)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.4,72.9h0l-8.8,33.6c5.6,1.6,11.2,2.4,16.8,4l5.6-24Z",
    transform: "translate(-56.66 -0.01)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,81.7h0l-8.8,34.4.8.8c24,8,42.4,20.8,42.4,42.4l96,96c1.6-5.6,3.2-11.2,4.8-16a147.66,147.66,0,0,0,3.2-18.4Z",
    transform: "translate(-56.66 -0.01)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.4,371.3l-72.8-72.8-3.2,12-20.8-5.6,6.4-24.8-14.4-14.4h0l-8.8,34.4L184,294.5v-.8l-.8.8,87.2,87.2C287.2,380.9,303.2,376.9,318.4,371.3Z",
    transform: "translate(-56.66 -0.01)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.4,361.7,252,275.3h-.8l-8.8,35.2-20-4.8,72.8,72.8A201.7,201.7,0,0,0,338.4,361.7Z",
    transform: "translate(-56.66 -0.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.e522d8cb1daeb3a60099800fd32f20e9.svg";
export { ForwardRef as ReactComponent };